import EmailUser from "@/domain/entities/emails/EmailUser";
import { MailSender } from "@cs_teamwaydev/mailvista-sdk_react";

const emailUserMapper = (user: MailSender): EmailUser =>
    new EmailUser({
        name: user.name,
        email: user.email,
        avatarUrl: user.avatarUrl,
    });

export default emailUserMapper;
